import { render, staticRenderFns } from "./table-size.vue?vue&type=template&id=fe8ed75c&scoped=true"
import script from "./table-size.vue?vue&type=script&lang=js"
export * from "./table-size.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8ed75c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe8ed75c')) {
      api.createRecord('fe8ed75c', component.options)
    } else {
      api.reload('fe8ed75c', component.options)
    }
    module.hot.accept("./table-size.vue?vue&type=template&id=fe8ed75c&scoped=true", function () {
      api.rerender('fe8ed75c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/com-public/com-yd-table/components/table-bar/components/table-size.vue"
export default component.exports